/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Offer_SendInputs */

const en_us2_gallery_offer_send = /** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send for review`)
};

const pt_br2_gallery_offer_send = /** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para revisão`)
};

const pt_pt2_gallery_offer_send = /** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar para revisão`)
};

/** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */
const es_419_gallery_offer_send = en_us2_gallery_offer_send;

/** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */
const fr_fr2_gallery_offer_send = en_us2_gallery_offer_send;

/** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */
const de_de2_gallery_offer_send = en_us2_gallery_offer_send;

/** @type {(inputs: Gallery_Offer_SendInputs) => LocalizedString} */
const it_it2_gallery_offer_send = en_us2_gallery_offer_send;

/**
* | output |
* | --- |
* | "Send for review" |
*
* @param {Gallery_Offer_SendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_offer_send = /** @type {((inputs?: Gallery_Offer_SendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Offer_SendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_offer_send(inputs)
	if (locale === "es-419") return es_419_gallery_offer_send(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_offer_send(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_offer_send(inputs)
	if (locale === "de-DE") return de_de2_gallery_offer_send(inputs)
	if (locale === "it-IT") return it_it2_gallery_offer_send(inputs)
	return en_us2_gallery_offer_send(inputs)
});
export { gallery_offer_send as "gallery.offer_send" }